import { Text } from "@ui-kit/Text/Text";

import "./TextHeadingWithBody.css";

interface TextHeadingWithBodyProps {
  headingText: string;
  bodyText: string;
  headingSize: "Xlarge" | "Large" | "Medium" | "Small" | "Xsmall";
  bodySize: "Large" | "Medium" | "Small";
  align: "start" | "center" | "end";
  gap: number;
  /**
   * If true, the heading and body will be displayed in reverse order, with the body on top of the heading.
   */
  reverse?: boolean;
}

const TextHeadingWithBody = ({
  headingText,
  bodyText,
  headingSize,
  bodySize,
  align,
  gap,
  reverse,
}: TextHeadingWithBodyProps) => {
  return (
    <div
      className={`text-heading-with-body-${align}`}
      style={{
        gap: `${gap}px`,
        flexDirection: reverse ? "column-reverse" : "column",
      }}>
      {headingText && (
        <Text variant={`fontHeading${headingSize}`}>{headingText}</Text>
      )}
      {bodyText && <Text variant={`fontBody${bodySize}`}>{bodyText}</Text>}
    </div>
  );
};

export { TextHeadingWithBody };
